import { Box, Fade, Typography } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import State from 'states/types'
import { mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
  }
}

type AppProps = StateProps & DispatchProps

const CalendarFC: React.FC<any> = (props: AppProps) => {
  console.log(props.layout.language.translations.messages)

  return (
    <Fade in={true} timeout={1000}>
      <Box
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        width={1}
        minHeight={'100vh'}
        padding={1}
        paddingTop={2}
        sx={{ transition: '.5s' }}
      >
        <Typography variant={'h2'} gutterBottom>
          My Calendar
        </Typography>
        <Box sx={{ maxWidth: '90vw', overflowX: 'auto' }}>
          <iframe
            id={'open-web-calendar'}
            style={{
              background:
                "url('https://raw.githubusercontent.com/niccokunzmann/open-web-calendar/master/static/img/loaders/circular-loader.gif') center center no-repeat",
              border: 0,
              borderRadius: '12px'
            }}
            src={
              'https://open-web-calendar.hosted.quelltext.eu/calendar.html?url=https%3A%2F%2Fwww.calendarlabs.com%2Fical-calendar%2Fics%2F46%2FGermany_Holidays.ics&css=.event%2C%20.dhx_cal_tab.active%2C%20.dhx_cal_tab.active%3Ahover%20%7Bbackground-color%3A%20Open%20Web%20Calendar%3B%7D%20.dhx_month_head%2C%20.dhx_cal_tab%2C%20.dhx_cal_today_button%20%7Bcolor%3A%20Open%20Web%20Calendar%3B%7D%20.dhx_cal_tab%2C%20.dhx_cal_tab.active%20%7Bborder-color%3A%20Open%20Web%20Calendar%3B%7D%0A.dhx_month_body%2C%20.dhx_month_head%2C%20.dhx_cal_container%20%7B%20background-color%3A%20Open%20Web%20Calendar%3B%20%7D%0A'
            }
            sandbox={'allow-scripts allow-same-origin allow-top-navigation'}
            height={800}
            width={1200}
          />
        </Box>
      </Box>
    </Fade>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations
})

const Calendar = connect(mapStateToProps, mapDispatchToProps)(CalendarFC)

export default Calendar
